<div class="container">
  <div class="row">
    <div class="col-12">
      <app-title-with-back (backClicked)="onBack()" [showButton]="stepper.currentIndex > 0 && stepper.currentIndex < 3">
        Creación de Solicitudes
      </app-title-with-back>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <uni-stepper stepperId="request" #stepper>
        <uni-step label="Información del Solicitante">
          <section class="col-md-6 mx-auto">
            <app-customer-form></app-customer-form>
          </section>
        </uni-step>

        <uni-step label="Datos de la Solicitud">
          <section class="col-8 col-lg-7 col-sm-12 mx-auto">
            <app-request-data-form></app-request-data-form>
          </section>
          <aside aria-label="Resumen del formulario paso 2" class="col-4 col-lg-5 col-sm-12 mx-auto">
            <app-side-summary></app-side-summary>
          </aside>
        </uni-step>

        <uni-step label="Documentos">
          <section class="col-8 col-lg-7 col-sm-12 mx-auto">
            <app-documents
              (submitForm)="onComplete()"
              [currentFilesUpload]="currentFilesUploaded"
              (currentFilesListEvent)="setCurrentFilesList($event)"
              (currentFilesUploadAllEvent)="setCurrentFilesUploaded($event)"
            ></app-documents>
          </section>
          <aside aria-label="Resumen del formulario paso 3" class="col-4 col-lg-5 col-sm-12 mx-auto">
            <app-side-summary
              [currentFilesUploaded]="currentFilesUploaded"
              [currentFilesList]="currentFilesList"
              [setCurrentFilesUploaded]="setCurrentFilesUploaded.bind(this)"
            ></app-side-summary>
          </aside>
        </uni-step>

        <uni-step label="Confirmación">
          <section class="col-md-7 col-sm-10 mx-auto">
            <app-confirmation></app-confirmation>
          </section>
        </uni-step>
      </uni-stepper>
    </div>
  </div>
</div>
